import { Button, Text } from '@resultadosdigitais/tangram-components';
import styled from 'styled-components';

import { useChat } from '../context/chat';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: var(--size-spacing-02);
  padding: var(--size-spacing-05) 0;
  border-top: 1px solid var(--neutral-border);

  @container (min-width: 1024px) {
    flex-direction: row;
  }
`;

const StyledText = styled(Text)`
  margin: 0;
  padding: 0;
`;

export const Reset = () => {
  const { reset, status } = useChat();

  if (status !== 'finished') {
    return null;
  }

  return (
    <Container>
      <StyledText
        textColor="--neutral-text-low-emphasis"
        token={Text.tokens.TEXT_MD_REGULAR}
      >
        Essa conversa foi finalizada automaticamente.
      </StyledText>
      <Button kind={Button.kinds.tertiary} onClick={reset}>
        Clique aqui para iniciar uma nova conversa
      </Button>
    </Container>
  );
};
